import React from 'react';
import { CoverControlBox, SwitchControl, MeterControl, OptimizerControl, LightControl, GateControlBox } from '..';
import { SensorControlBox } from '../../../../../../components/sensor-control-box';
import { BinarySensorTypeInternal, ChannelTypeInternal } from '../../../../../../data-access/gql-types/graphql';
import { useChannelsStateStore } from '../../../../store/channels-state';
import {
  ChannelBinarySensorStateType,
  ChannelSensorStateType,
  ChannelType,
  CoverKindParam,
  GateKindParam,
} from '../../../../types/channel';
import { FloodControl } from '../binary-sensor/flood';
import { InputControl } from '../binary-sensor/input';
import { MovementControl } from '../binary-sensor/movement';
import { ReedControl } from '../binary-sensor/reed';

type ChannelBoxControlsProps = {
  channel: ChannelType;
  isListItem?: boolean;
};

export const ChannelBoxControls: React.FC<ChannelBoxControlsProps> = ({ channel, isListItem }) => {
  const state = useChannelsStateStore((s) => s.channelState[channel.id]);

  switch (channel.data.type) {
    case ChannelTypeInternal.Meter:
      return <MeterControl channel={channel} />;
    case ChannelTypeInternal.Optimizer:
      return <OptimizerControl channel={channel} />;
    case ChannelTypeInternal.Blind:
      return <CoverControlBox channel={channel} isListItem={isListItem} kind={CoverKindParam.Channel} />;
    case ChannelTypeInternal.Gate:
      return <GateControlBox channel={channel} isListItem={isListItem} kind={GateKindParam.Channel} />;
    case ChannelTypeInternal.Switch:
      return <SwitchControl channel={channel} />;
    case ChannelTypeInternal.Light:
      return <LightControl channel={channel} />;
    case ChannelTypeInternal.Sensor: {
      const value = (state as ChannelSensorStateType).value;

      return (
        <SensorControlBox
          isListItem={isListItem}
          value={value != null ? Number(value.toFixed(2)) : null}
          unit={channel.data.unit}
          padding="0 10px"
        />
      );
    }

    case ChannelTypeInternal.BinarySensor: {
      const binarySensorValue =
        (state as ChannelBinarySensorStateType).value != null
          ? Boolean((state as ChannelBinarySensorStateType).value)
          : null;

      switch (channel.data.sensorType) {
        case BinarySensorTypeInternal.Flood:
          return <FloodControl value={binarySensorValue} />;
        case BinarySensorTypeInternal.Movement:
          return <MovementControl value={binarySensorValue} />;
        case BinarySensorTypeInternal.ReedSwitch:
          return <ReedControl value={binarySensorValue} />;
        case BinarySensorTypeInternal.Input:
          return <InputControl value={binarySensorValue} />;
        default:
          return null;
      }
    }

    default:
      return null;
  }
};
